import { createContext } from 'react';
import { FsEventContextValue } from '../type';

export const fsHitsContextInitial: FsEventContextValue = {
  fsHitsState: {
    hits: [],
  },
  fsHitsDispatch: () => {},
};

export const FsHitsContext = createContext(fsHitsContextInitial);
